var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.181,
    height: 70.181,
    viewBox: "0 0 70.181 70.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cd0f41;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.1,0H19.656A19.391,19.391,0,0,0,.29,19.366V50.815A19.391,19.391,0,0,0,19.656,70.181H51.1A19.391,19.391,0,0,0,70.471,50.815V19.366A19.391,19.391,0,0,0,51.1,0ZM64.244,50.815A13.155,13.155,0,0,1,51.1,63.954H19.656A13.155,13.155,0,0,1,6.518,50.815V19.366A13.155,13.155,0,0,1,19.656,6.228H51.1A13.155,13.155,0,0,1,64.244,19.366Z",
    transform: "translate(-0.29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.168,6.075A18.92,18.92,0,1,0,42.088,25,18.944,18.944,0,0,0,23.168,6.075Zm0,30.957A12.037,12.037,0,1,1,35.209,25,12.05,12.05,0,0,1,23.168,37.033ZM43.544,3.167a4.356,4.356,0,1,0,3.088,1.276A4.385,4.385,0,0,0,43.544,3.167Z",
    transform: "translate(10.485 8.607)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.88627b4c7d00916bcc7f76ec69f08882.svg";
export { ForwardRef as ReactComponent };